import localforage from 'localforage';
import moment from 'moment';
const goods = {
  state: {
    hasSavedData: false,
    autoSaveData: {
      form1: {},
      form2: {},
      form3: {}
    },
    radioValue: '1',
    time: null,
  },
  mutations: {
    async ['GOODSSAVEDATA'](state, { data: { form1, form2, form3 }, radioValue }) {
      await Promise.all([localforage.setItem('autoSaveData', { form1, form2, form3 }),
        localforage.setItem('radioValue', radioValue),
        localforage.setItem('time', new Date().getTime()),
        localforage.setItem('hasSavedData', 1),
      ]);
    },
    async ['GOODSUPDATESABED'](state) {
      const result = await Promise.all([
        localforage.getItem('autoSaveData'),
        localforage.getItem('radioValue'),
        localforage.getItem('time'),
        localforage.getItem('hasSavedData')
      ]);
      state.autoSaveData = result[0] || {
        form1: {},
        form2: {},
        form3: {}
      };
      state.radioValue = result[1] || '1';
      state.time = result[2] ? moment(result[2]) : null;
      state.hasSavedData = !!result[3] || false;
      console.log(state);
    }
  }
}

export default goods;